
import Landing from "../components/home/Landing";
import Components from "../components/home/Components";
import GetStarted from "../components/home/GetStarted";
import CompoLibrary from "../components/home/CompoLibrary";
import Features from "../components/home/Features";
import IconSupport from "../components/home/IconSupport";
// import Footer from "../components/controls/Footer";

const Home = () => {
    return (
        <div className="doc">
            <Landing />
            <GetStarted />
            <CompoLibrary />            
            <Components />
            <IconSupport />
            <Features />
        </div>

    )
};

export default Home;
